import { ref, computed, watchEffect, onMounted } from 'vue'
import { useProduct } from '@/api/composables/useProduct'
import { resourcesService } from '@/api/resources.service'
import type { Praeparat } from '@/types/otc/praeparat'

export function useProductDetailsCommon(productId: number, praeparatId: number) {
    const dictionary = ref<Record<string, string>>({})
    const praeparat = ref<Praeparat | null>(null)
    const { data: productData, loading: isProductLoading } = useProduct(productId)

    const isLoading = computed(() => isProductLoading.value)

    const praeparatList = computed<Praeparat[]>(() => productData.value?.praeparate ?? [])

    const bgColor = computed(() => {
        const f = praeparat.value?.otcKategorie?.farbe ?? ''
        return f.startsWith('#') ? f : `#${f}`
    })

    const fontColor = computed(() => {
        const f = praeparat.value?.otcKategorie?.fond ?? ''
        return f.startsWith('#') ? f : `#${f}`
    })

    const docLabel = computed(() =>
        dictionary.value['PRODUKTE_fachinfo'] ?? 'Fach- und Gebrauchsinformationen zum Download'
    )

    function selectPraeparat() {
        if (!praeparatList.value.length) return
        let selected = praeparatList.value[0]
        if (praeparatId) {
            const p = praeparatList.value.find((x: any) => x.id === praeparatId)
            if (p) selected = p
        }
        praeparat.value = selected
    }

    watchEffect(selectPraeparat)

    onMounted(async () => {
        dictionary.value = await resourcesService.dictionaryArea('PRODUKTE')
    })

    return {
        dictionary,
        praeparat,
        productData,
        isLoading,
        praeparatList,
        bgColor,
        fontColor,
        docLabel
    }
}